<div class="chat-message" [ngClass]="{ 'gray-background': index % 2 === 0 }">
  <div class="message-header">
    <app-chat-user-logo [senderType]="dialogMessage.senderKind"></app-chat-user-logo>
    <span class="sender-name"> {{ senderName }} ({{ senderTypeString | translate }}) </span>
    <span class="message-date">{{ hoursString }}</span>
    @if (isTenantInvolved && !dialogMessage.showToTenant) {
      <span class="message-tenant-visibility"
        ><img src="assets/icons/component_icons/eye-slash-black.png" />{{ 'CHAT.MESSAGE.DONT_SHOW_TENANT' | translate }}</span
        >
      }
      @if (dialogMessage.canDeleteMessage) {
        <span (click)="deleteMessage()" class="delete-button"><img src="assets/icons/component_icons/backet-main.png" /></span>
      }
    </div>

    <div class="message-header-mobile">
      <app-chat-user-logo [senderType]="dialogMessage.senderKind"></app-chat-user-logo>
      <span class="sender-name"> {{ senderName }} ({{ senderTypeString | translate }}) </span>
    </div>

    <div class="message-subheader-mobile">
      <span class="message-date">{{ hoursString }}</span>
      @if (isTenantInvolved && !dialogMessage.showToTenant) {
        <span class="message-tenant-visibility"
          ><img src="assets/icons/component_icons/eye-slash-black.png" />{{ 'CHAT.MESSAGE.DONT_SHOW_TENANT' | translate }}</span
          >
        }
        @if (dialogMessage.canDeleteMessage) {
          <span (click)="deleteMessage()" class="delete-button"><img src="assets/icons/component_icons/backet-main.png" /></span>
        }
      </div>

      <div class="message-read">
        @if (dialogMessage.isRead) {
          <p class="message-read-by">
            {{ 'CHAT.MESSAGE.READ_BY' | translate }} <b>{{ readBy }}</b> ({{ dateString }})
          </p>
        }
        @if (dialogMessage.canMarkAsUnread) {
          <mat-checkbox (change)="checkMessageAsUnread()" [disabled]="messageCheckAsUnreadBlocked">{{
            'CHAT.MESSAGE.MARK_UNREAD' | translate
          }}</mat-checkbox>
        }
        @if (!dialogMessage.isRead && dialogMessage.canMarkAsRead) {
          <mat-checkbox (change)="checkMessageAsRead()" [disabled]="messageCheckAsReadBlocked">{{
            'CHAT.MESSAGE.MARK_READ' | translate
          }}</mat-checkbox>
        }
      </div>
      <div class="message-body">
        @if (dialogMessage.header && dialogMessage.header.length > 0) {
          <p>
            <b>{{ dialogMessage.header }}</b>
          </p>
        }
        <p>{{ dialogMessage.text }}</p>
      </div>
      <div class="message-files">
        @if (attachmentsRerenderFlag) {
          <app-chat-message-files [files]="dialogMessage.attachments"></app-chat-message-files>
        }
      </div>
    </div>
